<template lang="pug">
button.btn.btn-primary.btn-icon-suffix(type="submit", :class="{'btn-success': state == 'success', 'btn-danger': state == 'error'}")
  slot
  icon(icon="spinner", spin, v-show="state == 'loading'")
  icon(icon="check-circle", v-show="state == 'success'")
  icon(icon="times", v-show="state == 'error'")
</template>

<script>
import {has,get} from 'lodash-es'

export default {
  name: 'AppSubmit',
  inheritAttrs: false,
  inject: {
    appForm: {
      default: ''
    }
  },
  data: () => ({
    state: ''
  }),
  computed: {
    hasState() {
      return !!this.state
    }
  },
  mounted() {
    this.appForm.$on('loading', state => this.updateState('loading'))
    this.appForm.$on('success', state => this.updateState('success'))
    this.appForm.$on('error', state => this.updateState('error'))
    this.appForm.$on('finished', state => this.startReset())
  },
  methods: {
    updateState(state) {
      this.state = state

    },
    startReset() {
      this.cooldown = setTimeout(() => this.updateState(''), 1000)
    }
  }
}
</script>
